var FHSPROD = FHSPROD || new Object();
FHSPROD.labelme = FHSPROD.labelme || new Object();
FHSPROD.labelme.labels = [{"id":823,"name":"Label","position":"custom","position_prod_pg":null,"css_inline":"","css_class":"","priority":1,"height":12,"width":36,"type":0,"display_type":1,"size_type":1,"div_style":"background-image: url(\"https:\/\/cdn.shopify.com\/s\/files\/1\/1847\/5307\/t\/21\/assets\/fhs-1495039176.png?5111274796408726523\"); background-position: 0% 0%; background-size: contain; background-repeat: no-repeat; width: 36%; height: 12%; opacity: 1; border-style: none; border-width: 1px; border-color: rgb(236, 13, 147); font-family: null; font-size: 14px; font-style: normal; font-weight: bold; color: rgb(255, 255, 255); padding-top: 3px; padding-left: 5px; z-index: 1; transform: rotate(0deg); text-align: center; position: absolute; top: 4%; right: 4%;","text_style":"text-shadow:;transform: rotate(0deg) !important;-webkit-transform: rotate(0deg) !important;-moz-transform: rotate(0deg) !important;","font_name":null,"label_image":"https:\/\/cdn.shopify.com\/s\/files\/1\/1847\/5307\/t\/21\/assets\/fhs-1495039176.png?5111274796408726523","display_text":" ","new_threshold":null,"new_start_dt":"09\/26\/2019","new_end_dt":"09\/26\/2019","sale_percent":null,"sale_amt":null,"sale_percent_max":0,"sale_amt_max":0,"expi_dt":"09\/26\/2019","low_stock_quantity":0,"exclude_products":"","exclude_collections":"","include_tags":"","exclude_tags":"","show_on_collection_pg":1,"show_on_product_pg":1,"compare_ind":0,"apply_products":[],"apply_collections":"417019788"},{"id":824,"name":"Label","position":"custom","position_prod_pg":null,"css_inline":"","css_class":"","priority":1,"height":22,"width":50,"type":0,"display_type":1,"size_type":1,"div_style":"background-image: url(\"https:\/\/cdn.shopify.com\/s\/files\/1\/1847\/5307\/t\/21\/assets\/fhs-1494332340.png?11678746322507662550\"); background-position: 0% 0%; background-size: contain; background-repeat: no-repeat; width: 50%; height: 22%; opacity: 1; border-style: none; border-width: 1px; border-color: rgb(236, 13, 147); font-family: null; font-size: 14px; font-style: normal; font-weight: bold; color: rgb(255, 255, 255); padding-top: 3px; padding-left: 5px; z-index: 1; transform: rotate(0deg); text-align: center; position: absolute; top: 3%; right: 4%;","text_style":"text-shadow:1px 1px 3px #cccccc;transform: rotate(0deg) !important;-webkit-transform: rotate(0deg) !important;-moz-transform: rotate(0deg) !important;","font_name":null,"label_image":"https:\/\/cdn.shopify.com\/s\/files\/1\/1847\/5307\/t\/21\/assets\/fhs-1494332340.png?11678746322507662550","display_text":"","new_threshold":null,"new_start_dt":"09\/26\/2019","new_end_dt":"09\/26\/2019","sale_percent":null,"sale_amt":null,"sale_percent_max":0,"sale_amt_max":0,"expi_dt":"09\/26\/2019","low_stock_quantity":0,"exclude_products":"","exclude_collections":"","include_tags":"","exclude_tags":"","show_on_collection_pg":1,"show_on_product_pg":1,"compare_ind":0,"apply_products":[],"apply_collections":"423832716"},{"id":1195,"name":"Multi-Pack","position":"custom","position_prod_pg":null,"css_inline":"","css_class":"","priority":1,"height":18,"width":45,"type":0,"display_type":1,"size_type":1,"div_style":"background-image: url(\"https:\/\/cdn.shopify.com\/s\/files\/1\/1847\/5307\/t\/21\/assets\/fhs-1493909030.png?12487807621520106933\"); background-position: 0% 0%; background-size: contain; background-repeat: no-repeat; width: 45%; height: 18%; opacity: 1; border-style: none; border-width: 1px; border-color: rgb(236, 13, 147); font-family: null; font-size: 14px; font-style: normal; font-weight: bold; color: rgb(255, 255, 255); padding-top: 3px; padding-left: 5px; z-index: 1; transform: rotate(0deg); text-align: center; position: absolute; top: 4%; right: 4%;","text_style":"text-shadow:1px 1px 3px #cccccc;transform: rotate(0deg) !important;-webkit-transform: rotate(0deg) !important;-moz-transform: rotate(0deg) !important;","font_name":null,"label_image":"https:\/\/cdn.shopify.com\/s\/files\/1\/1847\/5307\/t\/21\/assets\/fhs-1493909030.png?12487807621520106933","display_text":"","new_threshold":null,"new_start_dt":"09\/26\/2019","new_end_dt":"09\/26\/2019","sale_percent":null,"sale_amt":null,"sale_percent_max":0,"sale_amt_max":0,"expi_dt":"09\/26\/2019","low_stock_quantity":0,"exclude_products":"","exclude_collections":"","include_tags":"","exclude_tags":"","show_on_collection_pg":1,"show_on_product_pg":1,"compare_ind":0,"apply_products":[],"apply_collections":"429816652"},{"id":7359,"name":"Label","position":"custom","position_prod_pg":"","css_inline":"","css_class":"","priority":1,"height":30,"width":28,"type":0,"display_type":1,"size_type":1,"div_style":"background-image: url(\"https:\/\/cdn.shopify.com\/s\/files\/1\/1847\/5307\/t\/35\/assets\/fhs-1569498757.png?590\"); background-position: 0% 0%; background-size: contain; background-repeat: no-repeat; z-index: 1; width: 28%; height: 30%; opacity: 1; position: absolute; top: 60%; bottom: 2%; left: 2%;","text_style":"text-shadow:1px 1px 3px #cccccc;transform: rotate(0deg);-webkit-transform: rotate(0deg); -moz-transform: rotate(0deg);","font_name":null,"label_image":"https:\/\/cdn.shopify.com\/s\/files\/1\/1847\/5307\/t\/35\/assets\/fhs-1569498757.png?590","display_text":"","new_threshold":null,"new_start_dt":"09\/26\/2019","new_end_dt":"09\/26\/2019","sale_percent":null,"sale_amt":null,"sale_percent_max":0,"sale_amt_max":0,"expi_dt":"09\/26\/2019","low_stock_quantity":0,"exclude_products":"","exclude_collections":"","include_tags":"Sale Item","exclude_tags":"","show_on_collection_pg":1,"show_on_product_pg":1,"compare_ind":0,"apply_products":[{"id":"10406398028","title":"Donald Trump Keyring | America","handle":"donald-trump-keyring-america"}],"apply_collections":""}];
FHSPROD.labelme.settings = {"add_wrapper":0,"show_on_all_variant_images":0,"mobile_ratio":"0.75","max_viewpot_ratio":"0.75","viewpot_ratio":"0.65","max_mobile_screen_width":240,"support_mobile":1,"support_small_viewpot":0,"wrap_exact_img_tag":0,"show_collection_page":1,"show_product_page":0,"show_product_page_related":0,"stop_on_first_image":1,"scale_on_hover":0,"show_multiple_labels":1,"selector_prod":null,"selector_coll":null,"selector_prod_ext":null,"selector_coll_ext":null,"label_class_ext":null,"label_style_ext":null,"label_coll_class_ext":null,"label_coll_style_ext":null,"observer_selector":null,"observer_enable":0,"show_on_search_page":0,"allow_search_product":"1"};

var loadScript = function(url, callback) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    if (script.readyState) {
        script.onreadystatechange = function() {
            if (script.readyState == 'loaded' || script.readyState == 'complete') {
                script.onreadystatechange = null;
                callback();
            }
        }
    } else {
        script.onreadystatechange = callback;
        script.onload = callback;
    }
    script.src = url;
    document.head.appendChild(script);
};
var labelInit = function(FHSPROD, jQuery) {
	
    //console.debug('labelInit()');
    jQuery.cookie = function(b, j, m) {
        if (typeof j != 'undefined') {
            m = m || {};
            if (j === null) {
                j = '';
                m.expires = -1;
            }
            var e = '';
            if (m.expires && (typeof m.expires == 'number' || m.expires.toUTCString)) {
                var f;
                if (typeof m.expires == 'number') {
                    f = new Date();
                    f.setTime(f.getTime() + (m.expires * 24 * 60 * 60 * 1000));
                } else {
                    f = m.expires;
                }
                e = '; expires=' + f.toUTCString();
            }
            var l = m.path ? '; path=' + (m.path) : '';
            var g = m.domain ? '; domain=' + (m.domain) : '';
            var a = m.secure ? '; secure' : '';
            document.cookie = [b, '=', encodeURIComponent(j), e, l, g, a].join('');
        } else {
            var d = null;
            if (document.cookie && document.cookie != '') {
                var k = document.cookie.split(';');
                for (var h = 0; h < k.length; h++) {
                    var c = jQuery.trim(k[h]);
                    if (c.substring(0, b.length + 1) == (b + '=')) {
                        d = decodeURIComponent(c.substring(b.length + 1));
                        break;
                    }
                }
            }
            return d;
        }
    };
    FHSPROD.labelCookie = {
        name: 'fhs_label_me',
        setCookieStatus: function() { //installed, failed, re-installed, expired
            jQuery.cookie(this.name, 'installed');
        }
    };
    FHSPROD.labelCookie.setCookieStatus();
    if (FHSPROD.labelme.loadedApp === true) {
        return;
    }
    if ((typeof FHSPROD) == 'undefined') {
        var FHSPROD = {};
    }
    if ((typeof FHSPROD.labelme) == 'undefined') {
        FHSPROD.labelme = {};
    }
    if ((typeof FHSPROD.labelme.labels) == 'undefined') {
    	FHSPROD.labelme.labels = [];
    }
    if ((typeof FHSPROD.labelme.settings) == 'undefined') {
    	FHSPROD.labelme.settings = {"add_wrapper":0,"max_mobile_screen_width":425,"max_viewpot_ratio":0.75,"mobile_ratio":0.65
    		,"show_on_all_variant_images":0,"support_mobile":1,"support_small_viewpot":1,"viewpot_ratio":0.65 
    		,"wrap_exact_img_tag":0, "show_collection_page":1,"show_product_page":1,"show_product_page_related":1, "stop_on_first_image":0, "scale_on_hover":1};
    }
    FHSPROD.isDefined = function(obj) {
        return ((typeof obj == 'undefined') ? false : true);
    };
    FHSPROD.getPositionLeft = function(elem, strCssRule) {
        return 0;
    };
    FHSPROD.getPositionTop = function(elem, strCssRule) {
        return 0;
    };
    FHSPROD.getMarginW = function(elem, strCssRule) {
        var bordT = elem.outerWidth() - elem.innerWidth();
        var paddT = elem.innerWidth() - elem.width();
        var margT = elem.outerWidth(true) - elem.outerWidth();
        return margT / 2;
    };
    FHSPROD.getMarginH = function(elem, strCssRule) {
        var bordT = elem.outerHeight() - elem.innerHeight();
        var paddT = elem.innerHeight() - elem.height();
        var margT = elem.outerHeight(true) - elem.outerHeight();
        return margT / 2;
    };
    FHSPROD.getPadding = function(elem, strCssRule) {
        var bordT = elem.outerWidth() - elem.innerWidth();
        var paddT = elem.innerWidth() - elem.width();
        var margT = elem.outerWidth(true) - elem.outerWidth();
        return paddT;
    };
    FHSPROD.labelme.labelMain = function(variantId, image) {
        var product = FHSPROD.labelme.product_main;
        for (var i = 0; i < product.variants.length; i++) {
            var variant = product.variants[i];
            if (variantId == variant.id) {
                break;
            }
        }
        var match_count = 0;
        var labels = FHSPROD.labelme.labels;
        for (var id in labels) {
            var label = labels[id];

            //exclude products
            if(label.exclude_products && label.exclude_products.indexOf(product.id) >= 0){
            	continue;
            }
            
            //exclude collections
            if(label.exclude_collections){
            	var ids = label.exclude_collections.split(',');
            	var is_excluded = false;
        		for (var i = 0; i < ids.length; i++) {
        			if(product.collection_ids.indexOf(ids[i]) >=0 ){
        				is_excluded = true;
            			break;
            		}    
        		}
        		if(is_excluded == true) continue;
            }
            
            var condition = label.conditions;
            
            if (label.hide) {
                if (match_count > 0) {
                    continue;
                }
            }
            
            match = FHSPROD.labelme.matchLabel(product, label, image, FHSPROD.labelme.showMatchLabelSingle);
            
            if (match) {
                match_count++;
            } else {
                continue;
            }
            
            
        }
    };
    FHSPROD.labelme.showMatchLabelSingle = function(product, label, image, display_text ){
    	
    	var $image = jQuery(image);
    	var pwidth = $image.width();
    	var pheight = $image.height();
	    //console.debug('labelMain()');
    	
    	var $flickity = jQuery(image).parents('.flickity-viewport');
    	var $imageParent;
    	if($flickity.length > 0){
    		$imageParent = $flickity.first();
    	}else{
    		$imageParent = jQuery(image).parents(':not(a):not(ul):not(li)').first();
    	}
    	var $parent = $imageParent.parent();
    	//$imageParent.detach();
    	
        $imageParent.addClass("fhs-parent");
        
        if(FHSPROD.labelme.settings.add_wrapper == 1){
		    //jQuery(image).parents(':not(a)').eq(0).wrap(jQuery(fhswrapper));
	        if($imageParent.parent().hasClass('fhs-wrapper') == false){
	        	var $plcontainer = jQuery('<div class=\"fhs-wrapper fhs-product\">').css({
	    			//width: image.width(),
	    			//height: image.height(),
	    			'margin-left': FHSPROD.getMarginW($image),
	    			'margin-right': FHSPROD.getMarginW($image),
	    			'margin-top': FHSPROD.getMarginH($image),
	    			'margin-bottom': FHSPROD.getMarginH($image),
	    			'position': 'relative',
	    			padding: FHSPROD.getPadding($image),
	    		});
	        	$imageParent.wrap($plcontainer);
			}
	        //jQuery('.fhs-wrapper .fhs-image').hide();
        }else{
        	$imageParent.css('position','relative');
        }
    	
    	var labelNodes = $imageParent.find('.fhs-image[data-label-id=\"' + label.id + '\"]');
        if (labelNodes.length > 0) {
            labelNodes.first().show();
        } else {
    		
    		var $newNode = jQuery('<div>');
    		$newNode.attr('data-label-id',label.id ).attr('class','fhs-image ' + label.css_class ).attr('style', label.div_style + label.css_inline);
    		var $textNode = jQuery('<div>');
    		$textNode.attr('style',label.text_style).text(display_text);    
    		$newNode.append($textNode);
            
    		var pos = label.position;
    		//var style = 'position: absolute;';
    		$newNode.css('position', 'absolute');
    		if('custom' == pos){
    			//top left already in div_style
    		}else if('topleft' == pos){
    			//style += 'top:0%;left:0%;';
    			$newNode.css('top', '0%');
    			$newNode.css('left', '0%');
    		}else if('topright' == pos){
    			//style += 'top:0%;right:0%;';
    			$newNode.css('top', '0%');
    			$newNode.css('right', '0%');
    		}else if('topcenter' == pos){
    			var csize = label.size_type==0?(((pwidth-label.width)/2)/pwidth)*100:(((100-label.width)/2));
    			//style += 'top:0%;left:'+ csize + '%'+';';
    			$newNode.css('top', '0%');
    			$newNode.css('left', csize+'%');
    		}else if('bottomleft' == pos){
    			//style += 'bottom:0%;left:0%;';
    			$newNode.css('bottom', '0%');
    			$newNode.css('left', '0%');
    		}else if('bottomright' == pos){
    			//style += 'bottom:0%;right:0%;';
    			$newNode.css('bottom', '0%');
    			$newNode.css('right', '0%');
    		}else if('bottomcenter' == pos){
    			var csize = label.size_type==0?(((pwidth-label.width)/2)/pwidth)*100:(((100-label.width)/2));
    			//style += 'bottom:0%;left:'+ csize + '%'+';';
    			$newNode.css('bottol', '0%');
    			$newNode.css('left', csize + '%');
    		}else if('leftcenter' == pos){
    			var csize = label.size_type==0?(((pheight-label.height)/2)/pheight)*100:(((100-label.height)/2));
    			//style += 'top:'+ csize + '%'+';left:0%;';
    			$newNode.css('top', csize + '%');
    			$newNode.css('left', '0%');
    		}else if('rightcenter' == pos){
    			var csize = label.size_type==0?(((pheight-label.height)/2)/pheight)*100:(((100-label.height)/2));
    			//style += 'top:'+ csize + '%'+';right:0%;';
    			$newNode.css('top', csize + '%');
    			$newNode.css('right', '0%');
    		}else if('center' == pos){
    			var csize = label.size_type==0?(((pwidth-label.width)/2)/pwidth)*100:(((100-label.width)/2));
    			//style += 'top:'+ csize + '%'+';left:'+ csize + '%'+';';
    			$newNode.css('top', csize + '%');
    			$newNode.css('left',csize + '%');
    		}
    		//20 April 2017: CuongDV changed to append image to the imageParent instead of .fhs-wrapper
            //jQuery('.fhs-wrapper').append(newNode)
            //jQuery(imageParent).prepend(newNode);
    		
    		insertLabel($imageParent, label, pwidth, pheight, $newNode, display_text);
        }
        
        //$parent.append($imageParent);
    };
    FHSPROD.labelme.matchLabel = function(product, label, image, callback){
    	
    	var type = label.type;
        var display_text = label.display_text;
        var match = false;
        
    	if(label.apply_collections && label.apply_collections != ''){
        	if(product.collection_ids){
        		var ids = label.apply_collections.split(';');
        		for (var i = 0; i < ids.length; i++) {
        			if(product.collection_ids.indexOf(ids[i]) >=0 ){
            			match = true;
            			break;
            		}    
        		}
        	}
        }
        if(label.apply_products && label.apply_products.length > 0){
        	/*jQuery.each(label.apply_products, function(i, p) {
            if(p.handle === product.handle || p.id == product.id){
    			match = true;
    			return false;
    		}
	        });*/
	    	var apply_products_length = label.apply_products.length;
	    	for(var i=0; i< apply_products_length; i++){
	    		var p = label.apply_products[i];
	    		if(p.handle === product.handle || p.id == product.id){
	    			match = true;
	    			break;
	    		}
	    	}
        }
        if(type == 5){ //5=out of stock
        	if(product.total_quantity == 0){
        		match = true;
        	}
        }else if(type == 4){ //4=low stock quantity
        	if ( product.total_quantity > 0 && product.total_quantity  <= label.low_stock_quantity  ) {
        		if(display_text.indexOf('$q') >= 0){
        			display_text = display_text.replace('$q', product.total_quantity);
        		}
        		match = true;
            }
        }else if(type == 3){ //1=new, 2=sale,3=others

        	if (label.expi_dt) {
        		var newDate = new Date();
                if (Date.parse(label.expi_dt) >= Date.parse(newDate.toString())) {
                    match = true;
                }
            }

        }else if(type == 2){
        	var vlen = product.variants.length;
        	if(vlen > 0){ //process variants
        		var subMatch = false;
        		
        		for(var i=0; i< vlen; i++){
        			var v = product.variants[i];
        			if (v.compare_at_price_min && v.compare_at_price_min > 0 && v.price < v.compare_at_price_min) {
    	            	if(label.sale_percent > 0){
    	            		if(label.sale_percent <= ((v.compare_at_price_min - v.price) / v.compare_at_price_min)*100){
    	            			if(display_text.indexOf('$p') >= 0){
    	            				display_text = display_text.replace('$p', Math.round(((v.compare_at_price_min - v.price) / v.compare_at_price_min)*100));
    	            			}
    	            			subMatch = true;
    	            		}
    	            	}else if(label.sale_amt > 0){
    	            		if (label.sale_amt*100 <= (v.compare_at_price_min - v.price)) {
    	            			if(display_text.indexOf('$p') >= 0){
    	            				display_text = display_text.replace('$p', (v.compare_at_price_min - v.price)/100);
    	            			}
    	            			subMatch = true;
    	                    }
    	            	}else {
    	            		subMatch = true; //always show if above criterias not match
    	            	}
    	            }else if (v.compare_at_price_max && v.compare_at_price_max > 0 && v.price < v.compare_at_price_max) {
    	            	if(label.sale_percent > 0){
    	            		if(label.sale_percent <= ((v.compare_at_price_max - v.price) / v.compare_at_price_max)*100){
    	            			if(display_text.indexOf('$p') >= 0){
    	            				display_text = display_text.replace('$p', Math.round(((v.compare_at_price_max - v.price) / v.compare_at_price_max)*100));
    	            			}
    	            			subMatch = true;
    	            		}
    	            	}else if(label.sale_amt > 0){
    	            		if (label.sale_amt*100 <= (v.compare_at_price_max - v.price)) {
    	            			if(display_text.indexOf('$p') >= 0){
    	            				display_text = display_text.replace('$p', (v.compare_at_price_max - v.price)/100);
    	            			}
    	            			subMatch = true;
    	                    }
    	            	}else {
    	            		subMatch = true; //always show if above criterias not match
    	            	}
    	            }else if (v.compare_at_price && v.compare_at_price > 0  && v.price < v.compare_at_price) {
    	            	if(label.sale_percent > 0){
    	            		if(label.sale_percent <= ((v.compare_at_price - v.price) / v.compare_at_price)*100){
    	            			if(display_text.indexOf('$p') >= 0){
    	            				display_text = display_text.replace('$p', Math.round(((v.compare_at_price - v.price) / v.compare_at_price)*100));
    	            			}
    	            			subMatch = true;
    	            		}
    	            	}else if(label.sale_amt > 0){
    	            		if (label.sale_amt*100 <= (v.compare_at_price - v.price)) {
    	            			if(display_text.indexOf('$p') >= 0){
    	            				display_text = display_text.replace('$p', (v.compare_at_price - v.price)/100);
    	            			}
    	            			subMatch = true;
    	                    }
    	            	}else {
    	            		subMatch = true; //always show if above criterias not match
    	            	}
    	            }
        			
        			if(subMatch) {
        				break;
        			}
        		}
        		
        		if(match == false) {
        			match = subMatch;
        		}
        	}else{ //product does not have any variant
        		if (product.compare_at_price_min && product.compare_at_price_min > 0 && product.price < product.compare_at_price_min) {
	            	if(label.sale_percent > 0){
	            		if(label.sale_percent <= ((product.compare_at_price_min - product.price) / product.compare_at_price_min)*100){
	            			if(display_text.indexOf('$p') >= 0){
	            				display_text = display_text.replace('$p', Math.round(((product.compare_at_price_min - product.price) / product.compare_at_price_min)*100));
	            			}
	            			match = true;
	            		}
	            	}else if(label.sale_amt > 0){
	            		if (label.sale_amt*100 <= (product.compare_at_price_min - product.price)) {
	            			if(display_text.indexOf('$p') >= 0){
	            				display_text = display_text.replace('$p', (product.compare_at_price_min - product.price)/100);
	            			}
	                        match = true;
	                    }
	            	}else {
	            		match = true; //always show if above criterias not match
	            	}
	            }else if (product.compare_at_price_max && product.compare_at_price_max > 0 && product.price < product.compare_at_price_max) {
	            	if(label.sale_percent > 0){
	            		if(label.sale_percent <= ((product.compare_at_price_max - product.price) / product.compare_at_price_max)*100){
	            			if(display_text.indexOf('$p') >= 0){
	            				display_text = display_text.replace('$p', Math.round(((product.compare_at_price_max - product.price) / product.compare_at_price_max)*100));
	            			}
	            			match = true;
	            		}
	            	}else if(label.sale_amt > 0){
	            		if (label.sale_amt*100 <= (product.compare_at_price_max - product.price)) {
	            			if(display_text.indexOf('$p') >= 0){
	            				display_text = display_text.replace('$p', (product.compare_at_price_max - product.price)/100);
	            			}
	                        match = true;
	                    }
	            	}else {
	            		match = true; //always show if above criterias not match
	            	}
	            }else if (product.compare_at_price && product.compare_at_price > 0  && product.price < product.compare_at_price) {
	            	if(label.sale_percent > 0){
	            		if(label.sale_percent <= ((product.compare_at_price - product.price) / product.compare_at_price)*100){
	            			if(display_text.indexOf('$p') >= 0){
	            				display_text = display_text.replace('$p', Math.round(((product.compare_at_price - product.price) / product.compare_at_price)*100));
	            			}
	            			match = true;
	            		}
	            	}else if(label.sale_amt > 0){
	            		if (label.sale_amt*100 <= (product.compare_at_price - product.price)) {
	            			if(display_text.indexOf('$p') >= 0){
	            				display_text = display_text.replace('$p', (product.compare_at_price - product.price)/100);
	            			}
	                        match = true;
	                    }
	            	}else {
	            		match = true; //always show if above criterias not match
	            	}
	            }
        	}
        	
        }else if(type == 1){
        	
			 if (label.new_start_dt && label.new_end_dt) {
				 if(product.published_at_max && Date.parse(product.published_at_max.substring(0,10)) <= Date.parse(label.new_end_dt)){
					 match = true;
				 }
				 if (product.published_at_min && Date.parse(product.published_at_min.substring(0,10)) >= Date.parse(label.new_start_dt)) {
					 match = true;
				 }
				 if(product.published_at && Date.parse(product.published_at.substring(0,10)) >= Date.parse(label.new_start_dt)
						 && Date.parse(product.published_at.substring(0,10)) <= Date.parse(label.new_end_dt)){
					 match = true;
				 }
			 }
    	
    		if(label.new_threshold > 0){
				var newDate = new Date();
				newDate.setDate(newDate.getDate() - label.new_threshold);
				if(product.published_at && Date.parse(product.published_at.substring(0,10)) >= Date.parse(newDate.toString())){
					 match = true;
				}
				if (product.published_at_min && Date.parse(product.published_at_min.substring(0,10)) >= Date.parse(newDate.toString())){
					 match = true;
				}
			 }
        }
        if(match){
        	callback(product, label, image, display_text);
        }
        return match;
    };
    FHSPROD.labelme.labelList = function(product, image) {
        var match_count = 0;
        var labels = FHSPROD.labelme.labels;
        for (var id in labels) {
            var label = labels[id];
            
            //exclude products
            if(label.exclude_products && label.exclude_products.indexOf(product.id) >= 0){
            	continue;
            }
            
            //exclude collections
            if(label.exclude_collections){
            	var ids = label.exclude_collections.split(',');
            	var is_excluded = false;
        		for (var i = 0; i < ids.length; i++) {
        			if(product.collection_ids.indexOf(ids[i]) >=0 ){
        				is_excluded = true;
            			break;
            		}    
        		}
        		if(is_excluded == true) continue;
            }
            
            var match = false;
            if (label.hide) {
                if (match_count > 0) {
                    continue;
                }
            }
            
            match = FHSPROD.labelme.matchLabel(product, label, image, FHSPROD.labelme.showMatchLabelCollection);
            
            if (match) {
                match_count++
            } else {
                continue;
            }
            
        }
        return null;
    };
	
	function containerPadding($imageParent, $newNode){
		//check padding of imageParent
		//var matches;
		//matches = paddingLeft.match(/(\d+)(\w{2,3})/);
		
		var padding = $imageParent.css('padding-left');
		if(padding != ''){
			$newNode.css('margin-left', padding);
		}
		padding = $imageParent.css('padding-right');
		if(padding != ''){
			$newNode.css('margin-right', padding);
		}
		padding = $imageParent.css('padding-top');
		if(padding != ''){
			$newNode.css('margin-top', padding);
		}
		padding = $imageParent.css('padding-botom');
		if(padding != ''){
			$newNode.css('margin-botom', padding);
		}
	}
	function insertLabel($imageParent, label, pwidth, pheight, $newNode, display_text){
		
		if(label.size_type && label.size_type == 1){
			$newNode.css('min-height','50px').css('min-width','50px');
			$imageParent.append($newNode);
			return;
		}
		//var $newNode = jQuery(newNode);
		//var $imageParent = jQuery(imageParent);
		containerPadding($imageParent, $newNode);
		
		var deviceWidth = window.innerWidth || document.body.clientWidth;
    	if(FHSPROD.labelme.settings && FHSPROD.labelme.settings.support_mobile == 1 && FHSPROD.labelme.settings.max_mobile_screen_width >= deviceWidth){
    		if(display_text != ''){
    			var style = $newNode.children()[0].style;
    			style.transform = style.transform + ' scale(' + FHSPROD.labelme.settings.mobile_ratio + ') ';
    			style.webkitTransform  = style.webkitTransform  + ' scale(' + FHSPROD.labelme.settings.mobile_ratio + ') ';
    			style.MozTransform   = style.MozTransform  + ' scale(' + FHSPROD.labelme.settings.mobile_ratio + ') ';
    			style.msTransform   = style.msTransform  + ' scale(' + FHSPROD.labelme.settings.mobile_ratio + ') ';
    			style.OTransform   = style.OTransform  + ' scale(' + FHSPROD.labelme.settings.mobile_ratio + ') ';
    			style.transformOrigin = '25% 25%';
    			//jQuery(newNode).css('font-size','4.5vw');
    			
	    	}
    		if(label.mobile_width && label.mobile_width > 0){
    			$newNode.css('width', label.mobile_width + 'px').css('height', label.mobile_height + 'px');
				
    			$imageParent.append($newNode);
				
			}else if(FHSPROD.labelme.settings.mobile_ratio > 0){
				var newWidth = parseInt(label.width*FHSPROD.labelme.settings.mobile_ratio, 10);
				var newHeight = parseInt(label.height*FHSPROD.labelme.settings.mobile_ratio, 10);
				$newNode.css('width', newWidth + 'px').css('height', newHeight + 'px');
				
				label.mobile_width = newWidth;
				label.mobile_height = newHeight;
				
				$imageParent.append($newNode);
				
			}else{
				$imageParent.append($newNode);
			}
		}else if(FHSPROD.labelme.settings && FHSPROD.labelme.settings.support_small_viewpot == 1){
			
		    if(FHSPROD.labelme.settings.max_viewpot_ratio > 0 
		    		&& FHSPROD.labelme.settings.max_viewpot_ratio < (label.width/pwidth)){
		    	if(display_text != ''){
		    		var style = $newNode.children()[0].style;
		    		style.transform = style.transform + ' scale(' + FHSPROD.labelme.settings.viewpot_ratio + ') ';
	    			style.webkitTransform  = style.webkitTransform  + ' scale(' + FHSPROD.labelme.settings.viewpot_ratio + ') ';
	    			style.MozTransform   = style.MozTransform  + ' scale(' + FHSPROD.labelme.settings.viewpot_ratio + ') ';
	    			style.msTransform   = style.msTransform  + ' scale(' + FHSPROD.labelme.settings.viewpot_ratio + ') ';
	    			style.OTransform   = style.OTransform  + ' scale(' + FHSPROD.labelme.settings.viewpot_ratio + ') ';
	    			style.transformOrigin = '25% 25%';
		    		//jQuery(newNode).css('font-size','4.5vw');
		    	}
		    	
		    	if(label.viewpotWidth && label.viewportHeight){
		    		$newNode.css('width', label.viewpotWidth + 'px').css('height', label.viewpotHeight + 'px');
		    		$imageParent.append($newNode);
					
				}else{
			    	var newWidth = parseInt(label.width*FHSPROD.labelme.settings.viewpot_ratio, 10);
					var newHeight = parseInt(label.height*FHSPROD.labelme.settings.viewpot_ratio, 10);
					$newNode.css('width', newWidth + 'px').css('height', newHeight + 'px');
					
					label.viewpotWidth = newWidth;
					label.viewpotHeight = newHeight;
					
					$imageParent.append($newNode);
				}
		    }else{
		    	$imageParent.append($newNode);	
		    }
		}else{
			$imageParent.append($newNode);
		}
    };
    FHSPROD.labelme.showMatchLabelCollection = function(product, label, image, display_text ){
    	
        var $productImage = jQuery(image);

        var img = jQuery('img', $productImage);
        var pheight = $productImage.height();
        var pwidth = $productImage.width();
        
        if( pheight == 0 && img.length > 0){
        	pheight = img[0].height;	
        }
        if(pwidth == 0 && img.length > 0){
        	pwidth =img[0].width;	
        }
        
    	var $imageParent = jQuery(image).parents(':not(a)').first();
    	var $parent = $imageParent.parent();
    	//$imageParent.detach();
    	
    	$imageParent.addClass('fhs-parent');
        /*jQuery.each(jQuery("a[href*='"+product.handle+"']"), function(i, p) {
        	jQuery(p).parents(':not(a)').first().addClass('fhs-parent');
        });*/
        if(FHSPROD.labelme.settings.wrap_exact_img_tag == 1){
    		$imageParent = $productImage.find('img');
    		var $plcontainer = jQuery('<div class=\"fhs-wrapper fhs-collection\">').css({
            	//TODO optional fix width
                //width: $productImage.width(),
                //height: $productImage.height(),
                'margin-left': FHSPROD.getMarginW($productImage),
                'margin-right': FHSPROD.getMarginW($productImage),
                'margin-top': FHSPROD.getMarginH($productImage),
                'margin-bottom': FHSPROD.getMarginH($productImage),
                'position': 'relative',
                padding: FHSPROD.getPadding($productImage),
            });
    		$imageParent.eq(0).wrap($plcontainer);
    		$imageParent = $productImage.find('.fhs-wrapper');

    	}else if(FHSPROD.labelme.settings.add_wrapper == 1){
        	var $plcontainer = jQuery('<div class=\"fhs-wrapper fhs-collection\">').css({
            	//TODO optional fix width
                //width: $productImage.width(),
                //height: $productImage.height(),
                'margin-left': FHSPROD.getMarginW($productImage),
                'margin-right': FHSPROD.getMarginW($productImage),
                'margin-top': FHSPROD.getMarginH($productImage),
                'margin-bottom': FHSPROD.getMarginH($productImage),
                'position': 'relative',
                padding: FHSPROD.getPadding($productImage),
            });
        	$imageParent.eq(0).wrap($plcontainer);
        	/*jQuery.each(jQuery("a[href*='"+product.handle+"']"), function(i, p) {
            	jQuery(p).parents(':not(a)').eq(0).wrap(fhswrapper);
            });*/
    	}else{
    		$imageParent.css({'position': 'relative'});
		
		/*var imageParent = jQuery(image).parents(':not(a)').first();
    		imageParent.addClass('fhs-parent');
    		imageParent.css({'position': 'relative'});*/
		
    		/*jQuery.each(jQuery("a[href*='"+product.handle+"']"), function(i, p) {
            	jQuery(p).parents(':not(a)').first().css({
                    'position': 'relative'
                })
            });*/
    	}
    	var $labelNodes = $imageParent.find('.fhs-image[data-label-id=\"' + label.id + '\"]', image);
        if ($labelNodes.length > 0) {
            $labelNodes.first().show();
        } else {
            /*var newNode = '<div data-label-id="' + label.id + '" class="fhs-image ' + label.collectionImage.position + '" style="background-size: cover; background-image: url(' + label.collectionImage.image + '); width: ' + (label.collectionImage.label_width ? label.collectionImage.label_width : 30) + (label.collectionImage.fixed_size ? 'px' : '%') + '; height: ' + (label.collectionImage.label_height ? label.collectionImage.label_height : 30) + (label.collectionImage.fixed_size ? 'px' : '%') + ';position:absolute;">';*/
        	
    		
    		var $newNode = jQuery('<div>');
    		$newNode.attr('data-label-id',label.id ).attr('class','fhs-image ' + label.css_class ).attr('style', label.div_style+ label.css_inline);
    		var $textNode = jQuery('<div>');
    		$textNode.attr('style',label.text_style).text(display_text);    
    		$newNode.append($textNode);
    		
    		
    		var pos = label.position;
    		//var style = 'position: absolute;';
    		$newNode.css('position', 'absolute');
    		if('custom' == pos){
    			//top left already in div_style
    		}else if('topleft' == pos){
    			//style += 'top:0%;left:0%;';
    			$newNode.css('top', '0%');
    			$newNode.css('left', '0%');
    		}else if('topright' == pos){
    			//style += 'top:0%;right:0%;';
    			$newNode.css('top', '0%');
    			$newNode.css('right', '0%');
    		}else if('topcenter' == pos){
    			var csize = label.size_type==0?(((pwidth-label.width)/2)/pwidth)*100:(((100-label.width)/2));
    			//style += 'top:0%;left:'+ csize + '%'+';';
    			$newNode.css('top', '0%');
    			$newNode.css('left', csize+'%');
    		}else if('bottomleft' == pos){
    			//style += 'bottom:0%;left:0%;';
    			$newNode.css('bottom', '0%');
    			$newNode.css('left', '0%');
    		}else if('bottomright' == pos){
    			//style += 'bottom:0%;right:0%;';
    			$newNode.css('bottom', '0%');
    			$newNode.css('right', '0%');
    		}else if('bottomcenter' == pos){
    			var csize = label.size_type==0?(((pwidth-label.width)/2)/pwidth)*100:(((100-label.width)/2));
    			//style += 'bottom:0%;left:'+ csize + '%'+';';
    			$newNode.css('bottol', '0%');
    			$newNode.css('left', csize + '%');
    		}else if('leftcenter' == pos){
    			var csize = label.size_type==0?(((pheight-label.height)/2)/pheight)*100:(((100-label.height)/2));
    			//style += 'top:'+ csize + '%'+';left:0%;';
    			$newNode.css('top', csize + '%');
    			$newNode.css('left', '0%');
    		}else if('rightcenter' == pos){
    			var csize = label.size_type==0?(((pheight-label.height)/2)/pheight)*100:(((100-label.height)/2));
    			//style += 'top:'+ csize + '%'+';right:0%;';
    			$newNode.css('top', csize + '%');
    			$newNode.css('right', '0%');
    		}else if('center' == pos){
    			var csize = label.size_type==0?(((pwidth-label.width)/2)/pwidth)*100:(((100-label.width)/2));
    			//style += 'top:'+ csize + '%'+';left:'+ csize + '%'+';';
    			$newNode.css('top', csize + '%');
    			$newNode.css('left',csize + '%');
    		}
    		
    		insertLabel($imageParent, label, pwidth, pheight, $newNode, display_text);
    		
            //jQuery('.fhs-wrapper', element).prepend(newNode)
			//jQuery('.fhs-wrapper .fhs-parent').prepend(newNode)
            /*jQuery.each(jQuery("a[href*='"+product.handle+"']"), function(i, p) {
            	jQuery(p).parents(':not(a)').first().append(newNode)
            });*/
        }
        //$parent.append($imageParent);
    };
	function loadCSS(href) {
		var cssLink = $("<link rel='stylesheet' type='text/css' href='"+href+"'>");
		jQuery("head").append(cssLink);
	};
	function loadFont(fontName) {
		loadCSS('https://fonts.googleapis.com/css?family=' + fontName);
	};
    function findProductListImages() {
    	//04 April 2017: CuongDV remove below criteria to allow display label on related products
    	//:not(.related-products a[href*=\"/products/\"]) 
        var productImages = jQuery('a[href*=\"/products/\"]:not([href*=\".jp\"]):not(form a[href*=\"/products/\"]):not([href*=\".JP\"]):not([href*=\".png\"]):not([href*=\".PNG\"])').has('img[src*=\"/products/\"], img[src*=\"/no-image\"]');
        /*var products = {};
        productImages.each(function(index, product) {
            var splits = jQuery(product).attr('href').split('/');
            var handle = splits[splits.length - 1].split('?')[0];
            products[handle] = product
        });
        return products*/
        return productImages;
    };

    function findProductMainImages() {
    	var img_src = '';
    	var first_src = '';
    	if(FHSPROD.labelme.product_main.images[0]){
    		first_src = FHSPROD.labelme.product_main.images[0].src;
    		img_src = FHSPROD.labelme.product_main.images[0].src;
    		img_src = img_src.substr(0, img_src.indexOf('.'));
    	}
    	var i;
    	var matches;
		var images = [];
    	var allImages = jQuery('img[src*=\"/products/\"][src*=\"/cdn.shopify.com/s/files/\"][src*=\".jp\"],img[src*=\"/products/\"][src*=\"/cdn.shopify.com/s/files/\"][src*=\".JP\"],img[src*=\"/products/\"][src*=\"/cdn.shopify.com/s/files/\"][src*=\".png\"],img[src*=\"/products/\"][src*=\"/cdn.shopify.com/s/files/\"][src*=\".PNG\"]');
    	if(FHSPROD.labelme.settings.show_on_all_variant_images == 0 && img_src != '')
    	{
    		//find the first image
    		var firstImages = jQuery('img[src*=\"'+img_src+'\"]');
    		if(firstImages.length > 0){
				for(i=0; i<firstImages.length; i++){
					matches = firstImages[i].src.match(/(.*\/[\w\-\_\.]+)(\_compact|\_thumb|\_pico|\_small|\_icon|\_medium|\_grande|\_1024x1024|\_master)\.(\w{2,4})/);
					if(matches && matches[2] && matches[2] != '_thumb' && matches[2] != '_pico' && matches[2] != '_small' && matches[2] != '_icon' && matches[2] != '_compact'
						&& jQuery(firstImages[i]).is(':visible')){
						images.push(firstImages[i]);
						if(FHSPROD.labelme.settings.stop_on_first_image == 1){
							break;
						}
					}else if(jQuery(firstImages[i]).is(':visible')){
						images.push(firstImages[i]);
						if(FHSPROD.labelme.settings.stop_on_first_image == 1){
							break;
						}
					}
				}
				if(images.length == 0 && allImages.length > 0){
					images.push(firstImages[0]);
				}
				/*if(images.length == 0 && allImages.length > 0 && firstImages[0].src == allImages[0].src){
					images = firstImages[0];	
				}else if (allImages.length > 0 ){
					images = allImages[0];
				}else{
					images = firstImages[0];
				}*/
    		}else if (allImages.length > 0 ){
    			images.push(allImages[0]);
			}
			//falback check :to make sure at least 1 image selected
			if(images.length == 0 && firstImages.length > 0){
				images.push(firstImages[0]);
			}
    	}else{ //display on all images
			
			var pimage;
			var ilen = allImages.length;
			//for(var i=0; i< ilen; i++){
				//var aimage = allImages[i];

				for(var j=0; j<FHSPROD.labelme.product_main.images.length; j++){
					pimage = FHSPROD.labelme.product_main.images[j];
					matches = pimage.src.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
					if(matches && matches[1] && matches[1].length > 0){
						var matchImages = jQuery('img[src*=\"'+matches[1]+'\"]');
						if( matchImages.length > 0){
							images.push(matchImages);
						}
					}
				}
			//}
			//fallback check: to make sure images selected
			if(images.length == 0 ){
				var imageQuery = '';
				for(i=0; i<FHSPROD.labelme.product_main.images.length; i++){
					imageQuery += 'img[src*=\"'+FHSPROD.labelme.product_main.images[i].src+'\"],' ;
				}
				imageQuery = imageQuery.replace(/,(?=[^,]*$)/, '');
				images.push(jQuery(imageQuery));
			}
    	}
    	return images;
    };

    function getVariantId() {
        var variantId = null;
		return variantId;
		// if(Shopify.urlParam){
			// variantId= Shopify.urlParam('variant');
		// }
        // if (!variantId) {
            // var elem = document.getElementById(Shopify.OptionSelectors.domIdPrefix);
            // if (!elem) {
                // return false
            // }
            // var option = elem.querySelector('[selected]');
            // if (!option) {
                // return false
            // }
            // variantId = option.value
        // }
        // return variantId
    };
    
    function executeQuery(arrProductImages, queryUrl){

    	jQuery.ajax({
            url: queryUrl,
            dataType: 'text',
            type: 'post',
            success: function(text) {
            	 //console.debug(text);
            	try{
            		json = JSON.parse(text.substring(text.indexOf('START_FHSPROD')+13, text.lastIndexOf('END_FHSPROD')));
            	//console.debug(json)
            		if(json && json.results){
		            	var rlen = json.results.length;
		            	for(var i=0; i<rlen; i++){
		                	FHSPROD.labelme.products[json.results[i].handle] = json.results[i];
		                }
		                showLabels(arrProductImages);
            		}
            	}catch(err){
            		console.debug(text);
            		console.debug(err);
            	}
    		}
    	});
    };
    function searchMainProductByHandle(queryUrl){

    	jQuery.ajax({
            url: queryUrl,
            dataType: 'text',
            type: 'post',
            success: function(text) {
            	try{
            		json = JSON.parse(text.substring(text.indexOf('START_FHSPROD')+13, text.lastIndexOf('END_FHSPROD')));
            		if(json && json.results){
	            		var rlen = json.results.length;
	            		for(var i=0; i<rlen; i++){
	            			FHSPROD.labelme.product_main = json.results[i];
	            			var images = findProductMainImages();
	            			
	            			var ilen = images.length;
	            			for(var i=0; i<ilen; i++){
	            				var $image = jQuery(images[i]);
	            				FHSPROD.labelme.labelMain(FHSPROD.labelme.product_main.variants[0].id, $image);
	            			}
	            			break;
	            		}
            		}
            	}catch(err){
            		console.debug(text);
            		console.debug(err);
            	}
    		}
    	});
    };
    FHSPROD.labelme.productImages = {};
    function queryProduct(arrProductImages){
    	var fullQuery = "";
        var idx = 0;
        var startSlice = 0;
        var ilen = arrProductImages.length;
    	for(var i = 0; i<ilen; i++){
        //arrProductImages.each(function(index, product) {
    		var product = arrProductImages[i];
            var splits = jQuery(product).attr('href').split('/');
            var handle = splits[splits.length - 1].split('?')[0];
            if(handle.indexOf('#') > 0){
            	handle = handle.substring(0, handle.indexOf('#'));
            }
            
            if (fullQuery.length > 0) {
                fullQuery += " OR ";
            }
            fullQuery += "handle:\"" + handle + "\"";
            idx++;
            if (idx >= 5) {
                //jQuery.getScript('/search.js?q=' + fullQuery + '&view=fhsprod-labelme-json');
            	fullQuery = '/search.js?view=fhsprod-labelme-json&q=' + fullQuery;
            	executeQuery(arrProductImages.slice(startSlice, startSlice+idx), fullQuery);
            	startSlice += idx;
            	fullQuery = "";
            	idx = 0;
            }
        //});
    	}
        if (idx > 0) {
            //jQuery.getScript('/search.js?q=' + fullQuery + '&view=fhsprod-labelme-json')
        	fullQuery = '/search.js?view=fhsprod-labelme-json&q=' + fullQuery;
        	executeQuery(arrProductImages.slice(startSlice, startSlice+idx), fullQuery);
        	fullQuery = "";
        }
    };
    
    function showLabels(arrProductImages){
    	var ilen = arrProductImages.length;
    	for(var i=0; i<ilen; i++){
    		var productImage = arrProductImages[i];
    	//arrProductImages.each(function(index, productImage) {
            var splits = jQuery(productImage).attr('href').split('/');
            var handle = splits[splits.length - 1].split('?')[0];
            if(handle.indexOf('#') > 0){
            	handle = handle.substring(0, handle.indexOf('#'));
            }
            
            //save productImage[handle] for future use
            if (!FHSPROD.labelme.productImages.hasOwnProperty(handle)) {
            	FHSPROD.labelme.productImages[handle] = productImage;
            }
            
            var product = FHSPROD.labelme.products[handle];
            if(product){
            	FHSPROD.labelme.labelList(product, productImage);
            }
        //});
    	}
    };
    function addClassCss() {
    	jQuery('<style>')
	    .attr('type', 'text/css')
	    .html('div.fhs-image:hover{ -webkit-transition: all 200ms ease-in!important;'
	    	+'-webkit-transform: scale(1.1)!important;'
	        +'-ms-transition: all 200ms ease-in!important;-ms-transform: scale(1.1)!important;-moz-transition: all 200ms ease-in!important;-moz-transform: scale(1.1)!important;'
	        +'transition: all 200ms ease-in!important;transform: scale(1.1)!important;}'
	        +''
	    )
	        .appendTo('head');
	};
	
    jQuery(document).ready(function() {
    	if(FHSPROD.labelme.settings.scale_on_hover == 1){
    		addClassCss();
    	}
        jQuery('div.fhs-wrapper').remove();
        //load fonts
        //jQuery.each(FHSPROD.labelme.labels, function(i, label) {
        var llen = FHSPROD.labelme.labels.length;
        for(var i=0; i<llen; i++ ){
        	var label = FHSPROD.labelme.labels[i];
            if(label.font_name){
            	loadFont(label.font_name);
            }
	}
        //});
        if(typeof FHSPROD.labelme.pg === 'undefined' && (typeof FHSPROD.labelme.settings.show_product_page === 'undefined' 
        	|| FHSPROD.labelme.settings.show_product_page == 1))
        {
        	var storeURL = window.location.pathname;
        	if(storeURL){
        		var matches = storeURL.match(/(.*)\/(.*[products]+)\/(.*)/);
        		if(matches && matches[3]){
        			FHSPROD.labelme.pg = 'product';
        			storeURL = matches[3];
        			if (storeURL.indexOf("?")>-1){
        				storeURL = url.substr(0,storeURL.indexOf("?"));
        			}
    				//search product main
					 var q = "handle:\"" + storeURL + "\"";
			         q = '/search.js?view=fhsprod-labelme-json&q=' + q;
			         searchMainProductByHandle(q);
        		}
        	}
        }else if (FHSPROD.labelme.pg == 'product' && (typeof FHSPROD.labelme.settings.show_product_page === 'undefined' 
        	|| FHSPROD.labelme.settings.show_product_page == 1)) {

        	var images = findProductMainImages();
			
			//jQuery(images).each(function(i, image){
        	var ilen = images.length;
        	for(var i=0; i<ilen; i++){
        		var image = images[i];
				if (image) {
					var variantId = getVariantId();
					if (!variantId) {
						variantId = FHSPROD.labelme.product_main.variants[0].id;
					}
					FHSPROD.labelme.labelMain(variantId, jQuery(image));
				}
				/*jQuery(window).resize(function() {
					var images = findProductMainImages();
					jQuery(images).each(function(i, image){
						jQuery('.fhs-product').css({
							//TODO optional fix width
							//width: image.width(),
							//height: image.height(),
							'margin-left': FHSPROD.getMarginW(jQuery(image)),
							'margin-right': FHSPROD.getMarginW(jQuery(image)),
							'margin-top': FHSPROD.getMarginH(jQuery(image)),
							'margin-bottom': FHSPROD.getMarginH(jQuery(image)),
							'position': 'relative',
							padding: FHSPROD.getPadding(jQuery(image)),
						});
					});
				});
				jQuery('.single-option-selector').change(function() {
					if (!FHSPROD.isDefined(Shopify.urlParam) || !FHSPROD.isDefined(Shopify.OptionSelectors)) {
						//console.log('No Shopify.OptionSelectors');
						return;
					}
					var variantId = getVariantId();
					if (!variantId) {
						//console.log('no variantId');
						return false;
					}
					FHSPROD.labelme.labelMain(variantId, image, image.width(), image.height(), $plcontainer);
				});*/
			//});
        	}
        }
        
        if ( (typeof FHSPROD.labelme.settings.show_collection_page == 'undefined' || FHSPROD.labelme.settings.show_collection_page == 1)
        		&& (typeof FHSPROD.labelme.pg === 'undefined' 
        			|| FHSPROD.labelme.pg == 'collection' 
        				|| FHSPROD.labelme.pg == '' 
        					|| FHSPROD.labelme.pg == 'product')) {
            var arrProductImages = findProductListImages();
            if(typeof FHSPROD.labelme.product_list === 'undefined')
            	FHSPROD.labelme.product_list = [];
            //FHSPROD.labelme.productImages = productImages;
            //console.debug('Go collection page');
            FHSPROD.labelme.products = {};
            if(typeof FHSPROD_product_list !== 'undefined'){
            	FHSPROD.labelme.product_list = FHSPROD_product_list;
            }
            
            if(FHSPROD.labelme.product_list){
            	var plen = FHSPROD.labelme.product_list.length;
            	for(var i=0; i<plen; i++){
	            //jQuery.each(FHSPROD.labelme.product_list, function(i, product) {
	                FHSPROD.labelme.products[FHSPROD.labelme.product_list[i].handle] = FHSPROD.labelme.product_list[i];
	            //});
            	}
            }
            if(FHSPROD.labelme.product_front){
            	var plen = FHSPROD.labelme.product_front.length;
            	for(var i=0; i<plen; i++){
	            //jQuery.each(FHSPROD.labelme.product_front, function(i, product) {
	                FHSPROD.labelme.products[FHSPROD.labelme.product_front[i].handle] = FHSPROD.labelme.product_front[i];
	            //});
            	}
            }
            if(FHSPROD.labelme.pg != 'product'
            	||(FHSPROD.labelme.pg == 'product' && (typeof FHSPROD.labelme.settings.show_product_page_related === 'undefined' 
            		|| FHSPROD.labelme.settings.show_product_page_related == 1))){
	            if(FHSPROD.labelme.product_list.length == 0){
	            	queryProduct(arrProductImages);
	            }else{
	            	showLabels(arrProductImages);
	            }
            }
            

            /*jQuery(window).resize(function() {
                var arrProductImages = findProductListImages();
                arrProductImages.each(function(index, productImage) {
                    $productImage = jQuery(productImage);
                    jQuery('.fhs-collection', productImage).css({
                    	//TODO optional fix width
                        //width: $productImage.width(),
                        //height: $productImage.height(),
                        'margin-left': FHSPROD.getMarginW($productImage),
                        'margin-right': FHSPROD.getMarginW($productImage),
                        'margin-top': FHSPROD.getMarginH($productImage),
                        'margin-bottom': FHSPROD.getMarginH($productImage),
                        'position': 'relative',
                        padding: FHSPROD.getPadding($productImage),
                    })
                });
            });*/
        }
		jQuery('.fhs-image').css('display','block');
    }) //end document.ready
};
if (FHSPROD.labelme.loadedJs === true) {
    FHSPROD.labelme.jQuery(document).ready(function() {
        labelInit(FHSPROD, FHSPROD.labelme.jQuery);
    })
} else {
    if (typeof jQuery === 'undefined') {
        loadScript('//code.jquery.com/jquery-1.11.1.min.js', function() {
            FHSPROD.jQuery = jQuery.noConflict(true);
            FHSPROD.jQuery(document).ready(function() {
                labelInit(FHSPROD, FHSPROD.jQuery);
            })
        })
    } else {
        jQuery(document).ready(function() {
            labelInit(FHSPROD, jQuery);
        })
    }
}